import { Button, Heading } from '@design-systems/canvas-ui'
import Icon, { MenuIcon, SearchIcon } from '@design-systems/react-icons'
import { ReactNode } from 'react'
import './loginPlaceholder.css'
import { messages } from './messages'

type LoginPlaceholderProps = {
    children?: ReactNode
}

export const LoginPlaceholder = ({ children }: LoginPlaceholderProps) => {
    return (
        <div className="hc8-pa-none" data-testid="login-placeholder">
            <div className="navbar-container">
                <Button
                    isIconOnly
                    className="navbar-menu-button"
                    aria-label={messages.open}
                    variant="ghost"
                >
                    <Icon
                        svg={MenuIcon}
                        className="navbar-icon"
                        size="lg"
                        aria-hidden
                    />
                </Button>
                <div className="navbar-heading">
                    <Heading className="kpi-heading hc8-fs-350">&nbsp;</Heading>
                    <Heading className="location-heading hc8-fs-050 hc8-lh-headline">
                        &nbsp;
                    </Heading>
                </div>
                <div className="navbar-container-right">
                    <Button
                        isIconOnly
                        className="navbar-menu-button"
                        aria-label={messages.search}
                        variant="ghost"
                    >
                        <Icon
                            svg={SearchIcon}
                            className="navbar-icon"
                            size="lg"
                            aria-hidden
                        />
                    </Button>
                </div>
            </div>
            <div className="login-placeholder-content">{children}</div>
        </div>
    )
}
